module.exports = __webpack_public_path__ + "media/images/page/play_ic-c61a4da4d395d28fc4685cb324076a51.svg";